import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CoInnoResponseCode extends Component {
    state = {
        CoInnoResponseCodeFilterLists:[],
        CoInnoResponseCodeFilterValue: '',
        isCoInnoResponseCodeFilterLoading: true
    };
    componentDidMount(){
        this.getCoInnoResponseCodeFilter(this.props.start_date,this.props.end_date);
    }
    restCoInnoResponseCodeFilterFilter() {
        this.setState({
            CoInnoResponseCodeFilterValue: [],
        })
    }
    getCoInnoResponseCodeFilter(start_date, end_date){
        this.setState({
        CoInnoResponseCodeFilterLists:[],
        CoInnoResponseCodeFilterValue: [],
        isCoInnoResponseCodeFilterLoading: true
        })
        axios.get(config.get('API_URL')+'/filters/get_co_inno_responsecode/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                start_date: start_date,
                end_date: end_date
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((tender_mode, index) => {
                    this.state.CoInnoResponseCodeFilterLists.push({value: tender_mode.co_inno_responsecode, label: tender_mode.co_inno_responsecode})
                });
            }
            this.setState({
                isCoInnoResponseCodeFilterLoading: false
            })
        });

    }


    changeCoInnoResponseCodeFilter(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.CoInnoResponseCodeFilterLists.findIndex(obj => obj.value==ids.value);
                this.state.CoInnoResponseCodeFilterLists.move(index,0).join(',');
            });
        }
        this.props.onSelectCoInnoResponseCodeFilter(optionSelected, tenderArray);
        this.setState({
            CoInnoResponseCodeFilterValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="tender_mode"
                isMulti
                value={this.state.CoInnoResponseCodeFilterValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeCoInnoResponseCodeFilter.bind(this)}
                options={this.state.CoInnoResponseCodeFilterLists}
                placeholderButtonLabel="Select [Bi Bank Response code]"
                isLoading={this.state.isCoInnoResponseCodeFilterLoading}
            />
        );

    }
}
export default CoInnoResponseCode;